module.exports = __webpack_public_path__ + "img/banner5.da926600.jpg";